const XmlEntities = require('html-entities/lib/xml-entities');
const xmlEntities = new XmlEntities();

export const encodeEntity = (text: string): string => xmlEntities.encode(text);
export const decodeEntity = (text: string): string => xmlEntities.decode(text);
